<p-dialog
  header="Update Medical Record Release"
  [modal]="true"
  [style]="{ 'min-height': '50rem', width: '60rem' }"
  transitionOptions="450ms cubic-bezier(0, 0, 0.2, 1)"
  [visible]="visible() ?? false"
  (onHide)="onHideDialog()"
  (onShow)="onShowDialog()"
  [closable]="false"
>
  <ng-template #header>
    <div class="w-full h-full flex flex-row justify-between">
      <div class="p-dialog-title">Update Medical Record Release</div>
      <div (click)="onClickClose()"><i class="fa-solid fa-xmark-large fa-lg px-2 cursor-pointer"></i></div>
    </div>
  </ng-template>

  <csl-patient-banner [patientLastFirstName]="patientLastFirstName()" [patientDateOfBirth]="patientDob()"></csl-patient-banner>

  <span class="p-text-secondary block mb-4 italic">The form below allows you to update the status of the Medical Record
    Release for the selected patient.   You can also view the history of the Medical Record Release.
    <span class="text-red-600">Requests for medical record release must follow the internal procedures of your clinic to determine if the request should be approved or denied.</span>
  </span>

  @if(mrrUpdateStore.selectedItem()) {

  <div class="p-5 -mb-3">
    <div class="font-semibold w-32 inline-block">Current Status</div>
    <div id="currentStatus" class="inline-block pl-4">{{ mrrUpdateStore.selectedItem()!.status! | lookup: 'mrrStatusName' }}</div>
  </div>

  <div id="mrrUpdateForm" class="p-5 mb-3">

    <form #updateForm="ngForm">

      <div class="flex items-center gap-4 mb-6">
        <label for="nextState" class="font-semibold w-32">New Status<i class="fa-solid fa-asterisk fa-2xs ml-1"></i></label>
        <p-select id="nextState" class="w-3/5"
                  [ngModel]="formUpdateMedicalRecordRelease().newStatus"
                  (ngModelChange)="formUpdateMedicalRecordRelease.update(f => ({...f, newStatus: $event}))"
                  [options]="mrrUpdateStore.nextStateOptions()"
                  [showClear]="true"
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Select new status"
                  name="nextState"
                  [required]="true"
                  [disabled]="!mrrUpdateStore.selectedItem()"
                  size="small"
        ></p-select>
      </div>

      <div class="flex items-center gap-4 mb-6">
        <label for="docComment" class="font-semibold w-32 inline-block">Comment</label>
        <p-floatlabel>
        <textarea pTextarea id="docComment" rows="3" cols="55"
                  [ngModel]="formUpdateMedicalRecordRelease().comment"
                  (ngModelChange)="formUpdateMedicalRecordRelease.update(f => ({...f, comment: $event}))"
                  name="docComment"
                  [disabled]="!mrrUpdateStore.selectedItem()">
        </textarea>
          <label for="docComment">Enter comment (optional)</label>
        </p-floatlabel>
      </div>

      <div class="pl-36">
        <p-button label="Update Status" severity="primary" (click)="onUpdateStatus()"
                  [disabled]="formUpdateMedicalRecordRelease().newStatus === null"
                  [hidden]="!mrrUpdateStore.selectedItem()" />
      </div>

    </form>

  </div>

  <p-divider></p-divider>

  <div id="mrrHistory" class="mb-5">

    <div class="border">
      <p-table
        [value]="mrrUpdateStore.selectedItem()?.events ?? []"
        [tableStyle]="{ 'width': '100%' }"
        [rows]="10"
        [scrollable]="true"
        sortField="eventAt"
        [sortOrder]="-1"
        size="small"
        scrollHeight="300px"
      >
        <ng-template #header>
          <tr>
            <th colspan="4" class="italic">
              History <span class="font-light not-italic">(reverse chronological order: newest first)</span>
            </th>
          </tr>
          <tr>
            <th style="width: 10%">Date<i class="ml-1 fa-solid fa-arrow-down-wide-short"></i></th>
            <th style="width: 20%">Person</th>
            <th style="width: 40%">Status</th>
            <th style="width: 30%">Comment</th>
          </tr>
        </ng-template>
        <ng-template #body let-event>
          <tr>
            <td>{{ event.eventAt | date: 'M/d/yyyy' }}</td>
            <td>{{ event.userName }}</td>
            <td>{{ event.status | lookup: 'mrrStatus' }}</td>
            <td>{{ event.comment }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>

  } @else {

    <div class="flex flex-col min-h-48 place-content-center">
      <i class="fa-solid fa-spinner fa-xl fa-spin"></i>
    </div>
  }

  <div class="flex justify-between">
    <div class="self-center"><i class="fa-solid fa-asterisk fa-2xs mr-1"></i>Required field</div>
  </div>


</p-dialog>
